var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#analytics_svg__clip0_61530_7240)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5H1.5V21A1.5 1.5 0 003 22.5h19.5V21H3V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.75h-5.25v1.5h2.692l-5.692 5.693-3.217-3.226a.75.75 0 00-1.066 0L4.5 16.192l1.058 1.058 4.942-4.943 3.217 3.226a.75.75 0 001.066 0L21 9.306V12h1.5V6.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "analytics_svg__clip0_61530_7240"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgAnalytics;